// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header-module__font-s-10___i7vvC {
  font-size: 10px !important;
}

.Header-module__font-s-12___lbkeZ {
  font-size: 12px !important;
}

.Header-module__font-s-13___uYQOE {
  font-size: 13px !important;
}

.Header-module__font-s-14___jejlM {
  font-size: 14px !important;
}

.Header-module__font-s-15___OGMdI {
  font-size: 15px !important;
}

.Header-module__font-s-16___YVuRz {
  font-size: 16px !important;
}

.Header-module__font-s-18___Ug9dE {
  font-size: 18px !important;
}

.Header-module__font-s-20___AAbE4 {
  font-size: 20px !important;
}

.Header-module__font-s-22___YBVUs {
  font-size: 22px !important;
}

.Header-module__font-s-28___ZkrZc {
  font-size: 28px !important;
}

.Header-module__font-w-400___UkPTf {
  font-weight: 400 !important;
}

.Header-module__font-w-500___KNvPJ {
  font-weight: 500 !important;
}

.Header-module__font-w-600___Wx1Mz {
  font-weight: 600 !important;
}

.Header-module__font-w-700___hSmoK {
  font-weight: 700 !important;
}

.Header-module__p-5___cs0gu {
  padding: 5px !important;
}

.Header-module__p-12___rMVfA {
  padding: 12px !important;
}

.Header-module__p-16___P8WGP {
  padding: 16px !important;
}

.Header-module__p-30___yw_xK {
  padding: 30px !important;
}

.Header-module__p-b-0___zyqGU {
  padding-bottom: 0 !important;
}

.Header-module__p-b-5___LmMf_ {
  padding-bottom: 5px !important;
}

.Header-module__p-b-10___fTGG5 {
  padding-bottom: 10px !important;
}

.Header-module__p-b-12___YSI83 {
  padding-bottom: 12px !important;
}

.Header-module__p-b-16___Zzp42 {
  padding-bottom: 16px !important;
}

.Header-module__p-b-18___QTgNA {
  padding-bottom: 18px !important;
}

.Header-module__p-b-20___MU1_p {
  padding-bottom: 20px !important;
}

.Header-module__p-b-25___PsYK9 {
  padding-bottom: 25px !important;
}

.Header-module__p-b-30___YIo4G {
  padding-bottom: 30px !important;
}

.Header-module__p-b-50___l7JmS {
  padding-bottom: 50px !important;
}

.Header-module__p-t-0___lXuR1 {
  padding-top: 0 !important;
}

.Header-module__p-t-12___rqASI {
  padding-top: 12px !important;
}

.Header-module__p-t-16___iNc0s {
  padding-top: 16px !important;
}

.Header-module__p-t-18___Wl0nY {
  padding-top: 18px !important;
}

.Header-module__p-t-20___Rl2Z5 {
  padding-top: 20px !important;
}

.Header-module__p-t-30___U1An1 {
  padding-top: 30px !important;
}

.Header-module__p-t-40___MbzZQ {
  padding-top: 40px !important;
}

.Header-module__p-t-50___MV9o5 {
  padding-top: 50px !important;
}

.Header-module__p-l-20___KThUW {
  padding-left: 20px !important;
}

.Header-module__p-l-30___spUoq {
  padding-left: 30px !important;
}

.Header-module__p-l-40___bsq3E {
  padding-left: 40px !important;
}

.Header-module__p-r-16___LEKPZ {
  padding-right: 16px !important;
}

.Header-module__p-r-20___N7cSY {
  padding-right: 20px !important;
}

.Header-module__p-r-30___IgGLQ {
  padding-right: 30px !important;
}

.Header-module__p-r-50___Zyuap {
  padding-right: 50px !important;
}

.Header-module__p-r-60___WzbCj {
  padding-right: 60px !important;
}

.Header-module__m-b-1___sQ3FD {
  margin-bottom: 1px !important;
}

.Header-module__m-b-2___yKUnP {
  margin-bottom: 2px !important;
}

.Header-module__m-b-6___NX7hS {
  margin-bottom: 6px !important;
}

.Header-module__m-b-8___BK8TH {
  margin-bottom: 8px !important;
}

.Header-module__m-b-10___ascAj {
  margin-bottom: 10px !important;
}

.Header-module__m-b-14___lbZ3Q {
  margin-bottom: 14px !important;
}

.Header-module__m-b-16___a8HN4 {
  margin-bottom: 16px !important;
}

.Header-module__m-b-20___CC6HK {
  margin-bottom: 20px !important;
}

.Header-module__m-b-22___j_4Nf {
  margin-bottom: 22px !important;
}

.Header-module__m-b-24___Z0x1q {
  margin-bottom: 24px !important;
}

.Header-module__m-b-30___DgXIY {
  margin-bottom: 30px !important;
}

.Header-module__m-b-32___iV1xe {
  margin-bottom: 32px !important;
}

.Header-module__m-b-40___aHz9D {
  margin-bottom: 40px !important;
}

.Header-module__m-t-2___F5vlb {
  margin-top: 2px !important;
}

.Header-module__m-t-3___AXNhy {
  margin-top: 3px !important;
}

.Header-module__m-t-4___nnw7s {
  margin-top: 4px !important;
}

.Header-module__m-t-5___mqTrs {
  margin-top: 5px !important;
}

.Header-module__m-t-8___Wld9n {
  margin-top: 8px !important;
}

.Header-module__m-t-10___bnR4E {
  margin-top: 10px !important;
}

.Header-module__m-t-15___kmxC9 {
  margin-top: 15px !important;
}

.Header-module__m-t-16___urZ9o {
  margin-top: 16px !important;
}

.Header-module__m-t-20___gXS8_ {
  margin-top: 20px !important;
}

.Header-module__m-t-22___lqiIu {
  margin-top: 22px !important;
}

.Header-module__m-t-30___AxXT3 {
  margin-top: 30px !important;
}

.Header-module__m-t-32___GxMP_ {
  margin-top: 32px !important;
}

.Header-module__m-l-auto___bLiNu {
  margin-left: auto !important;
}

.Header-module__m-l-4___X3WeY {
  margin-left: 4px !important;
}

.Header-module__m-l-5___B6pZs {
  margin-left: 5px !important;
}

.Header-module__m-l-6____Gv8N {
  margin-left: 6px !important;
}

.Header-module__m-l-8___V2iIP {
  margin-left: 8px !important;
}

.Header-module__m-l-10___XCDk6 {
  margin-left: 10px !important;
}

.Header-module__m-l-16___rwQRJ {
  margin-left: 16px !important;
}

.Header-module__m-l-20___UT7cV {
  margin-left: 20px !important;
}

.Header-module__m-l-24___LP49n {
  margin-left: 24px !important;
}

.Header-module__m-l-30___MqD16 {
  margin-left: 30px !important;
}

.Header-module__m-l-35___SMFyC {
  margin-left: 35px !important;
}

.Header-module__m-l-40___1I2qz {
  margin-left: 40px !important;
}

.Header-module__m-r-8___yPRh5 {
  margin-right: 8px !important;
}

.Header-module__m-r-10___fwL9u {
  margin-right: 10px !important;
}

.Header-module__m-r-16___gDgrW {
  margin-right: 16px !important;
}

.Header-module__m-r-20___cL_cl {
  margin-right: 20px !important;
}

.Header-module__m-r-24___z0EkO {
  margin-right: 24px !important;
}

.Header-module__m-r-30___yOxUN {
  margin-right: 30px !important;
}

.Header-module__m-r-40___uGE8L {
  margin-right: 40px !important;
}

.Header-module__border-r-3___eECpb {
  border-radius: 3px !important;
}

.Header-module__border-r-4___nsvkt {
  border-radius: 4px !important;
}

.Header-module__border-r-6___BwSnW {
  border-radius: 6px !important;
}

.Header-module__border-r-10___SDXEo {
  border-radius: 10px !important;
}

.Header-module__border-r-12___Naxz3 {
  border-radius: 12px !important;
}

.Header-module__border-r-16___EtCVz {
  border-radius: 16px !important;
}

.Header-module__border-r-50___dm_fB {
  border-radius: 50% !important;
}

.Header-module__primary-border___PxWfo {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Header-module__primary-border-b___SnRn8 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Header-module__primary-border-t___rTFbC {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Header-module__primary-border-l___vqX9R {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Header-module__primary-border-r___UBzl4 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Header-module__secondary-border___Lf5mP {
  border: 1px solid #637768;
}

.Header-module__secondary-border-b___ssK_U {
  border-bottom: 1px solid #637768;
}

.Header-module__secondary-border-t___ZpTh2 {
  border-top: 1px solid #637768;
}

.Header-module__secondary-border-l___Pf9_c {
  border-left: 1px solid #637768;
}

.Header-module__secondary-border-r___IP9Ki {
  border-right: 1px solid #637768;
}

.Header-module__gap-0___Sd0Yw {
  gap: 0 !important;
}

.Header-module__gap-2___tledZ {
  gap: 2px !important;
}

.Header-module__gap-4___Ws_yA {
  gap: 4px !important;
}

.Header-module__gap-5___kYilX {
  gap: 5px !important;
}

.Header-module__gap-6___ZRX0j {
  gap: 6px !important;
}

.Header-module__gap-8___CCJda {
  gap: 8px !important;
}

.Header-module__gap-10___WHE2d {
  gap: 10px !important;
}

.Header-module__gap-12___OKPSt {
  gap: 12px !important;
}

.Header-module__gap-14___zkPZ1 {
  gap: 14px !important;
}

.Header-module__gap-16___fDPLm {
  gap: 16px !important;
}

.Header-module__gap-18___t7Jj_ {
  gap: 18px !important;
}

.Header-module__gap-20___jHp69 {
  gap: 20px !important;
}

.Header-module__gap-24___BGhDB {
  gap: 24px !important;
}

.Header-module__gap-26___jUIsM {
  gap: 26px !important;
}

.Header-module__gap-30___xB5J6 {
  gap: 30px !important;
}

.Header-module__gap-32___l8Bkj {
  gap: 32px !important;
}

.Header-module__gap-40___TtM0X {
  gap: 40px !important;
}

.Header-module__gap-50___gtN74 {
  gap: 50px !important;
}

.Header-module__flex-1___Cp8lu {
  flex: 1;
}

.Header-module__flex-none___XHzxU {
  flex: none !important;
}

.Header-module__flex-column___SRYTZ {
  display: flex;
  flex-direction: column !important;
}

.Header-module__flex-row___SprgA {
  display: flex;
  flex-direction: row !important;
}

.Header-module__vertically-centered___FLaoI {
  display: flex;
  align-items: center !important;
}

.Header-module__horizontally-centered___PN8ea {
  display: flex;
  justify-content: center !important;
}

.Header-module__horizontally-end___MOnKa {
  display: flex;
  justify-content: end !important;
}

.Header-module__vertically-start___GdA1w {
  display: flex;
  align-items: start !important;
}

.Header-module__space-between___d3i9P {
  display: flex;
  justify-content: space-between !important;
}

.Header-module__flex-wrap___Pe78z {
  flex-wrap: wrap !important;
}

.Header-module__height-100___cwiEM {
  height: 100%;
}

.Header-module__width-50___xweYg {
  width: 50% !important;
}

.Header-module__width-100___sSSif {
  width: 100%;
}

.Header-module__cursor-pointer___jpQ3I {
  cursor: pointer;
}

.Header-module__cursor-not-allowed___H9S9M {
  cursor: not-allowed !important;
}

.Header-module__absolute-centered____WGG0 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Header-module__absolute___lnzYE {
  position: absolute;
}

.Header-module__relative___VVQGW {
  position: relative;
}

.Header-module__fixed___wAwxr {
  position: fixed;
}

.Header-module__visible____BcH5 {
  opacity: 1;
}

.Header-module__invisible___B8ucS {
  opacity: 0;
}

.Header-module__col-90___ezpgu {
  width: 90% !important;
}

.Header-module__col-auto___khKEh {
  width: auto !important;
}

.Header-module__medical-tabs___orKvF {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Header-module__medical-table-new___jegHF {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Header-module__medical-table-new___jegHF:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Header-module__medical-table-new___jegHF::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Header-module__medical-table-new___jegHF::-webkit-scrollbar-track {
  display: none;
}
.Header-module__medical-table-new___jegHF.Header-module__no-pagination___z4WuS {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Header-module__medical-table-new___jegHF.Header-module__no-pagination___z4WuS:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Header-module__medical-table-new___jegHF.Header-module__no-pagination___z4WuS::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Header-module__medical-table-new___jegHF.Header-module__no-pagination___z4WuS::-webkit-scrollbar-track {
  display: none;
}

.Header-module__medical-table-empty___SjwJJ {
  padding: 14px 40px !important;
}

.Header-module__icon-btn___ere2J {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Header-module__search-icon___J8cW8 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Header-module__disable-select___hjlbs {
  user-select: none;
}

.Header-module__break-word___XyY6N {
  word-break: break-word;
}

.Header-module__popup-clear-btn___BPZeB {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Header-module__scroll-m-b-20___uQgGW {
  scroll-margin-bottom: 20px;
}

.Header-module__header___w9YP7 {
  background-color: #fdfbf8;
  box-sizing: border-box;
  padding: 0 40px;
  height: 75px;
}
.Header-module__header___w9YP7 > * {
  flex: 1;
  height: 41px;
  box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/fragments/TimelineFragment/Header/Header.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;AA8pBF;AA5pBE;EACE,OAAA;EACA,YAAA;EACA,sBAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.header {\n  background-color: get-color(grayNew, lighter);\n  box-sizing: border-box;\n  padding: 0 40px;\n  height: 75px;\n\n  & > * {\n    flex: 1;\n    height: 41px;\n    box-sizing: border-box;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Header-module__font-s-10___i7vvC`,
	"fontS12": `Header-module__font-s-12___lbkeZ`,
	"fontS13": `Header-module__font-s-13___uYQOE`,
	"fontS14": `Header-module__font-s-14___jejlM`,
	"fontS15": `Header-module__font-s-15___OGMdI`,
	"fontS16": `Header-module__font-s-16___YVuRz`,
	"fontS18": `Header-module__font-s-18___Ug9dE`,
	"fontS20": `Header-module__font-s-20___AAbE4`,
	"fontS22": `Header-module__font-s-22___YBVUs`,
	"fontS28": `Header-module__font-s-28___ZkrZc`,
	"fontW400": `Header-module__font-w-400___UkPTf`,
	"fontW500": `Header-module__font-w-500___KNvPJ`,
	"fontW600": `Header-module__font-w-600___Wx1Mz`,
	"fontW700": `Header-module__font-w-700___hSmoK`,
	"p5": `Header-module__p-5___cs0gu`,
	"p12": `Header-module__p-12___rMVfA`,
	"p16": `Header-module__p-16___P8WGP`,
	"p30": `Header-module__p-30___yw_xK`,
	"pB0": `Header-module__p-b-0___zyqGU`,
	"pB5": `Header-module__p-b-5___LmMf_`,
	"pB10": `Header-module__p-b-10___fTGG5`,
	"pB12": `Header-module__p-b-12___YSI83`,
	"pB16": `Header-module__p-b-16___Zzp42`,
	"pB18": `Header-module__p-b-18___QTgNA`,
	"pB20": `Header-module__p-b-20___MU1_p`,
	"pB25": `Header-module__p-b-25___PsYK9`,
	"pB30": `Header-module__p-b-30___YIo4G`,
	"pB50": `Header-module__p-b-50___l7JmS`,
	"pT0": `Header-module__p-t-0___lXuR1`,
	"pT12": `Header-module__p-t-12___rqASI`,
	"pT16": `Header-module__p-t-16___iNc0s`,
	"pT18": `Header-module__p-t-18___Wl0nY`,
	"pT20": `Header-module__p-t-20___Rl2Z5`,
	"pT30": `Header-module__p-t-30___U1An1`,
	"pT40": `Header-module__p-t-40___MbzZQ`,
	"pT50": `Header-module__p-t-50___MV9o5`,
	"pL20": `Header-module__p-l-20___KThUW`,
	"pL30": `Header-module__p-l-30___spUoq`,
	"pL40": `Header-module__p-l-40___bsq3E`,
	"pR16": `Header-module__p-r-16___LEKPZ`,
	"pR20": `Header-module__p-r-20___N7cSY`,
	"pR30": `Header-module__p-r-30___IgGLQ`,
	"pR50": `Header-module__p-r-50___Zyuap`,
	"pR60": `Header-module__p-r-60___WzbCj`,
	"mB1": `Header-module__m-b-1___sQ3FD`,
	"mB2": `Header-module__m-b-2___yKUnP`,
	"mB6": `Header-module__m-b-6___NX7hS`,
	"mB8": `Header-module__m-b-8___BK8TH`,
	"mB10": `Header-module__m-b-10___ascAj`,
	"mB14": `Header-module__m-b-14___lbZ3Q`,
	"mB16": `Header-module__m-b-16___a8HN4`,
	"mB20": `Header-module__m-b-20___CC6HK`,
	"mB22": `Header-module__m-b-22___j_4Nf`,
	"mB24": `Header-module__m-b-24___Z0x1q`,
	"mB30": `Header-module__m-b-30___DgXIY`,
	"mB32": `Header-module__m-b-32___iV1xe`,
	"mB40": `Header-module__m-b-40___aHz9D`,
	"mT2": `Header-module__m-t-2___F5vlb`,
	"mT3": `Header-module__m-t-3___AXNhy`,
	"mT4": `Header-module__m-t-4___nnw7s`,
	"mT5": `Header-module__m-t-5___mqTrs`,
	"mT8": `Header-module__m-t-8___Wld9n`,
	"mT10": `Header-module__m-t-10___bnR4E`,
	"mT15": `Header-module__m-t-15___kmxC9`,
	"mT16": `Header-module__m-t-16___urZ9o`,
	"mT20": `Header-module__m-t-20___gXS8_`,
	"mT22": `Header-module__m-t-22___lqiIu`,
	"mT30": `Header-module__m-t-30___AxXT3`,
	"mT32": `Header-module__m-t-32___GxMP_`,
	"mLAuto": `Header-module__m-l-auto___bLiNu`,
	"mL4": `Header-module__m-l-4___X3WeY`,
	"mL5": `Header-module__m-l-5___B6pZs`,
	"mL6": `Header-module__m-l-6____Gv8N`,
	"mL8": `Header-module__m-l-8___V2iIP`,
	"mL10": `Header-module__m-l-10___XCDk6`,
	"mL16": `Header-module__m-l-16___rwQRJ`,
	"mL20": `Header-module__m-l-20___UT7cV`,
	"mL24": `Header-module__m-l-24___LP49n`,
	"mL30": `Header-module__m-l-30___MqD16`,
	"mL35": `Header-module__m-l-35___SMFyC`,
	"mL40": `Header-module__m-l-40___1I2qz`,
	"mR8": `Header-module__m-r-8___yPRh5`,
	"mR10": `Header-module__m-r-10___fwL9u`,
	"mR16": `Header-module__m-r-16___gDgrW`,
	"mR20": `Header-module__m-r-20___cL_cl`,
	"mR24": `Header-module__m-r-24___z0EkO`,
	"mR30": `Header-module__m-r-30___yOxUN`,
	"mR40": `Header-module__m-r-40___uGE8L`,
	"borderR3": `Header-module__border-r-3___eECpb`,
	"borderR4": `Header-module__border-r-4___nsvkt`,
	"borderR6": `Header-module__border-r-6___BwSnW`,
	"borderR10": `Header-module__border-r-10___SDXEo`,
	"borderR12": `Header-module__border-r-12___Naxz3`,
	"borderR16": `Header-module__border-r-16___EtCVz`,
	"borderR50": `Header-module__border-r-50___dm_fB`,
	"primaryBorder": `Header-module__primary-border___PxWfo`,
	"primaryBorderB": `Header-module__primary-border-b___SnRn8`,
	"primaryBorderT": `Header-module__primary-border-t___rTFbC`,
	"primaryBorderL": `Header-module__primary-border-l___vqX9R`,
	"primaryBorderR": `Header-module__primary-border-r___UBzl4`,
	"secondaryBorder": `Header-module__secondary-border___Lf5mP`,
	"secondaryBorderB": `Header-module__secondary-border-b___ssK_U`,
	"secondaryBorderT": `Header-module__secondary-border-t___ZpTh2`,
	"secondaryBorderL": `Header-module__secondary-border-l___Pf9_c`,
	"secondaryBorderR": `Header-module__secondary-border-r___IP9Ki`,
	"gap0": `Header-module__gap-0___Sd0Yw`,
	"gap2": `Header-module__gap-2___tledZ`,
	"gap4": `Header-module__gap-4___Ws_yA`,
	"gap5": `Header-module__gap-5___kYilX`,
	"gap6": `Header-module__gap-6___ZRX0j`,
	"gap8": `Header-module__gap-8___CCJda`,
	"gap10": `Header-module__gap-10___WHE2d`,
	"gap12": `Header-module__gap-12___OKPSt`,
	"gap14": `Header-module__gap-14___zkPZ1`,
	"gap16": `Header-module__gap-16___fDPLm`,
	"gap18": `Header-module__gap-18___t7Jj_`,
	"gap20": `Header-module__gap-20___jHp69`,
	"gap24": `Header-module__gap-24___BGhDB`,
	"gap26": `Header-module__gap-26___jUIsM`,
	"gap30": `Header-module__gap-30___xB5J6`,
	"gap32": `Header-module__gap-32___l8Bkj`,
	"gap40": `Header-module__gap-40___TtM0X`,
	"gap50": `Header-module__gap-50___gtN74`,
	"flex1": `Header-module__flex-1___Cp8lu`,
	"flexNone": `Header-module__flex-none___XHzxU`,
	"flexColumn": `Header-module__flex-column___SRYTZ`,
	"flexRow": `Header-module__flex-row___SprgA`,
	"verticallyCentered": `Header-module__vertically-centered___FLaoI`,
	"horizontallyCentered": `Header-module__horizontally-centered___PN8ea`,
	"horizontallyEnd": `Header-module__horizontally-end___MOnKa`,
	"verticallyStart": `Header-module__vertically-start___GdA1w`,
	"spaceBetween": `Header-module__space-between___d3i9P`,
	"flexWrap": `Header-module__flex-wrap___Pe78z`,
	"height100": `Header-module__height-100___cwiEM`,
	"width50": `Header-module__width-50___xweYg`,
	"width100": `Header-module__width-100___sSSif`,
	"cursorPointer": `Header-module__cursor-pointer___jpQ3I`,
	"cursorNotAllowed": `Header-module__cursor-not-allowed___H9S9M`,
	"absoluteCentered": `Header-module__absolute-centered____WGG0`,
	"absolute": `Header-module__absolute___lnzYE`,
	"relative": `Header-module__relative___VVQGW`,
	"fixed": `Header-module__fixed___wAwxr`,
	"visible": `Header-module__visible____BcH5`,
	"invisible": `Header-module__invisible___B8ucS`,
	"col90": `Header-module__col-90___ezpgu`,
	"colAuto": `Header-module__col-auto___khKEh`,
	"medicalTabs": `Header-module__medical-tabs___orKvF`,
	"medicalTableNew": `Header-module__medical-table-new___jegHF`,
	"noPagination": `Header-module__no-pagination___z4WuS`,
	"medicalTableEmpty": `Header-module__medical-table-empty___SjwJJ`,
	"iconBtn": `Header-module__icon-btn___ere2J`,
	"searchIcon": `Header-module__search-icon___J8cW8`,
	"disableSelect": `Header-module__disable-select___hjlbs`,
	"breakWord": `Header-module__break-word___XyY6N`,
	"popupClearBtn": `Header-module__popup-clear-btn___BPZeB`,
	"scrollMB20": `Header-module__scroll-m-b-20___uQgGW`,
	"header": `Header-module__header___w9YP7`
};
module.exports = ___CSS_LOADER_EXPORT___;
